import { Column } from 'src/model';
import { websiteColumnList } from 'src/utils/tableColumns';

export const SET_WEBCONTACTS_COLUMNS = 'SET_WEBCONTACTS_COLUMNS';
export const setWebcontactssColumns = (columns: Column[]) => ({
  type: SET_WEBCONTACTS_COLUMNS,
  payload: columns,
});

const initialState: Column[] = websiteColumnList;

interface Action {
  type: string;
  payload: Column[];
}

const setWebcontactColumnsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_WEBCONTACTS_COLUMNS:
      return [...action.payload];

    default:
      return state;
  }
};
export default setWebcontactColumnsReducer;
